import * as Tone from 'tone';
export class NoiseGenerator {
    constructor() {
        this.noise = new Tone.Noise("white");
        this.noise.volume.value = -96;
        // Simple filter sweep on the noise
        this.autoFilter = new Tone.AutoFilter({
            frequency: "8m",
        }).toDestination();
        // Slow LFO on noise frequency
        this.noise.connect(this.autoFilter);
    }
    start(noiseConfig) {
        console.log("NoiseGenerator::start");
        const { volume, filterFreqency } = noiseConfig;
        // Update the filter frequency
        this.autoFilter.frequency.rampTo(filterFreqency || "8m", "2m");
        // Update noise type / volume
        if (this.noise.state !== "started") {
            this.noise.start();
            this.autoFilter.start();
        }
        this.noise.volume.rampTo(volume || -48, "2m");
    }
    stop() {
        if (this.noise.state === "started") {
            this.noise.volume.rampTo(-128, "2m");
            this.noise.stop("+2m");
            this.autoFilter.stop("+2m");
        }
    }
}
